import { apiB2BWithBlob } from '../axios-client';
import { OMS_B2B_ORDER_DETAILS_PATH } from '../../constants/paths';
export var ExportOrderDetails = function (requestData) {
    return apiB2BWithBlob.post("".concat(OMS_B2B_ORDER_DETAILS_PATH, "/export"), requestData);
};
